export const Hero = () => {
  return (
    <div className="flex flex-col font-lato">
      <h2 className="mb-3 text-[36px]">Your Ultimate Custom Dashboard</h2>
      <h3 className="mb-5 text-[28px]">
        All your tools, one seamless experience
      </h3>
      <p className="text-[16px]">
        Create stunning pages filled with powerful widgets. Integrate the tools
        you use everyday to stay on top of everything that matters.
      </p>
    </div>
  );
};
